<template>
    <section>
        <!-- Todo list -->
        <template v-if="todoList.length > 0">
            <router-link
                    v-for="(todo, i) in todoList"
                    :key="i + '-todo'"
                    :to="generateTodoURL(todo)"
            >
                <ae-block>

                    <b-card class="notification-body-sections-cards">
                        <div class="row pl-3">
                            <div class="col-1 sections-cards-img p-0">
                                <img :src="'/static/img/icons/notifications/' + todo.icone" :alt="todo.titre"/>
                            </div>
                            <div class="col sections-cards-infos">
                                <h3>{{ todo.titre }}</h3>
                                <p>{{ todo.sous_titre }}</p>
                            </div>
                        </div>
                    </b-card>
                </ae-block>
            </router-link>
        </template>

        <!-- Notifications -->
        <template v-if="notifications.length > 0">
            <div
                v-for="(notification, i) in notifications"
                :key="i + '-notification'"
                class="mb-1"
                @click="markAsRead(notification.notification)">
                <router-link
                    class="style--default notification"
                    :to="generateURL(notification.notification, notification.objet)">
                    <b-card
                        class="notification-body-sections-cards"
                        :class="notification.notification.workflowState === 'created' ? 'notification--new' : ''">
                        <div class="row pl-3">
                            <div class="col-1 sections-cards-img p-0">
                                <img :src="'/static/img/icons/notifications/' + notification.icone"
                                     :alt="notification.titre"
                                     class="w-100"
                                />
                            </div>
                            <div class="col sections-cards-infos">
                                <h3>{{ notification.titre }}</h3>
                                <p>{{ notification.sous_titre }}</p>
                            </div>
                        </div>
                    </b-card>
                </router-link>
            </div>
        </template>
    </section>
</template>

<script>
    import basicErrorHandler from '@/utils/handlers/basicErrorHandler'
    import {LatLng} from 'leaflet';
    import AeBlock from "./Block";

    export default {
        name: 'notification-container',
        components: {AeBlock},
        props: {
            bordered: {
                type: Boolean,
                default: false
            },
            notifications: {
                type: Array,
                default: () => ([])
            },
            todoList: {
                type: Array,
                default: () => ([])
            }
        },
        methods: {
            generateURL(notification, objet) {
                let url = {name: 'notifications'};
                switch (notification.type) {
                    case 'campagne_todo':
                        url = {name: 'campaigns'};
                        break;
                    case 'friend_suggestion_by_automation':
                        url = {name: 'profile', params: {id: objet.friend.myUser.id}}
                        break
                    case 'friend_birthday':
                    case 'friend_accept':
                    case 'friend_reject':
                    case 'friend_add':
                        url = {name: 'profile', params: {id: notification.creator.id}};
                        break;
                    case 'presence_sheet_todo':
                    case 'creenau_presence_sheet_todo':
                    case 'creneau_notation_todo':
                        url = {name: 'meeting-presence', params: {id: objet.id}};
                        break;
                    case 'creneau_to_note':
                        url = {name: 'notifications'};
                        break;
                    case 'modification_seance_privee':
                    case 'creneau_invited':
                    case 'partage_creneau':
                    case 'seance_share':
                    case 'private_meeting_share':
                    case 'coach_deleguation_assign':
                    case 'modification_creneau':
                    case 'abonnement_alert_new_creneau':
                    case 'accept_waiting':
                    case 'coach_register_user':
                        url = {name: 'meeting', params: {id: objet.id}};
                        break;
                    case 'delegation_demande':
                        url = {name: 'delegations'};
                        break;
                    case 'coach_deleguation_accepted':
                    case 'annulation_seance_privee':
                    case 'annulation_creneau':
                        url = {name: 'notifications'};
                        break;
                    case 'cafe_invited':
                    case 'cafe_answer':
                        url = {name: 'coffee'};
                        break;
                    case 'invitation_add_group':
                        url = {name: 'community', params: {id: objet.id}};
                        break;
                    case 'doodle_reply':
                    case 'invitation_doodle':
                    case 'doodle_disponibility':
                        url = {name: 'doodle', params: {id: objet.id}};
                        break;
                    case 'generate_facture':
                        url = {name: 'shop-account'};
                        break;
                    case 'document_worker_uploaded':
                    case 'document_expire_soon':
                    case 'document_expired':
                        url = {name: 'documents'};
                        break;
                    case 'new_seance_type_available':
                        url = {name: 'video-list'};
                        break;
                    case 'share_route':
                        url = {
                            name: 'community',
                            params: {id: objet.communityId},
                            query: {tabName: 'routes', routeId: objet.id}
                        }
                        break
                    case 'programme_vie_ma_vie_todo':
                        url = {name: 'program-todo'}
                        break
                    case 'worker_relais_application':
                        url = {name: 'relais-application'}
                        break
                    case 'relance_report_relais':
                        url = { name: 'relais-roadlog', query: { tab: 'reminders' } }
                        break
                }
                return url;
            },
            generateTodoURL(todo) {
                switch (todo.type) {
                    case 'creneau_to_note':
                        return {name: 'meeting-presence', params: {id: todo.objet.id}}
                    case 'presence_sheet_todo':
                        return {name: 'meeting-presence', params: {id: todo.objet.id}}
                    case 'campaign':
                        return {name: 'campaigns'}
                    default:
                        return {name: 'roadlog'}
                }
            },
            async markAsRead({id: notificationId, etat}) {
                if (etat) return
                try {
                    const {status} = await this.$store.dispatch('base/notification/markAsRead', {notificationId})
                } catch (e) {
                    basicErrorHandler(e)
                }
            },
            async markAllAsRead() {
                try {
                    const notifications = this.$store.getters['base/notification/unreadList']
                    if (!notifications.length) return
                    await Promise.all(notifications.map(notification => this.markAsRead(notification)))
                } catch (e) {
                    basicErrorHandler(e)
                }
            }
        }
    }
</script>
